// extracted by mini-css-extract-plugin
export var truncate = "_13-0";